module.exports = __webpack_public_path__ + "img/car_shina2_11.28274b06.jpg";